export enum EventUpdaterEvents {
  NewEvent = 'NewEvent'
}
